module.exports = [{"title":"Возможен обмен","id":"is_swap"},{"title":"Безналичный расчёт","id":"is_cashless"},{"title":"Аренда","id":"is_rent"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/priceStatuses.json
// module id = 493
// module chunks = 49